import _ from 'lodash';

import membershipFields from 'bundles/accomplishments/promises/membershipFields';
import membershipsPromise from 'bundles/catalogP/promises/memberships';

const byCodeQuery = function (code: $TSFixMe) {
  const query = _.extend(
    {
      q: 'byCode',
      code,
      showHidden: true,
    },
    membershipFields
  );
  query.includes.signatureTrackProfile = {
    fields: ['firstName', 'middleName', 'lastName'],
  };

  const { course } = query.includes;
  course.fields.push('workload');
  course.includes.instructors = {
    fields: ['prefixName', 'firstName', 'middleName', 'lastName', 'suffixName', 'fullName', 'shortName', 'profileId'],
  };

  const { details } = course.includes;
  details.fields.push('aboutTheCourse', 'courseSyllabus');
  details.includes.sessions.fields.push('gradingPolicyNormal', 'gradingPolicyDistinction');

  return query;
};

const byCodeForUserQuery = function (code: $TSFixMe) {
  const query = _.extend(
    {
      q: 'byCodeForUser',
      code,
      showHidden: true,
    },
    membershipFields
  );
  query.includes.signatureTrackProfile = {
    fields: ['firstName', 'middleName', 'lastName'],
  };

  const { course } = query.includes;
  course.fields.push('workload');
  course.includes.instructors = {
    fields: ['prefixName', 'firstName', 'middleName', 'lastName', 'suffixName', 'fullName', 'shortName', 'profileId'],
  };

  const { details } = course.includes;
  details.fields.push('aboutTheCourse', 'courseSyllabus');
  details.includes.sessions.fields.push('gradingPolicyNormal', 'gradingPolicyDistinction');

  return query;
};

export default function (code: $TSFixMe, mustOwnCertificateToView: $TSFixMe) {
  if (mustOwnCertificateToView) {
    return membershipsPromise(byCodeForUserQuery(code)).then(function (memberships: $TSFixMe) {
      // The `byCode` finder returns at most one membership.
      return memberships.at(0);
    });
  } else {
    return membershipsPromise(byCodeQuery(code)).then(function (memberships: $TSFixMe) {
      // The `byCode` finder returns at most one membership.
      return memberships.at(0);
    });
  }
}
